export default __webpack_public_path__ + "static/media/vdt3.114b30e0.png";